module.exports = "https://www.gc-pro.gnp.com.mx/c3124462781fac9706790e8ccd485c22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/credit-card-visa.svg
// module id = 962
// module chunks = 0